import React from "react";
const Account = () => <div>Farmer Inventory</div>;

export default Account;